import { useState, useEffect, Children } from 'react';
import { useIntl } from 'gatsby-plugin-intl';
import PropTypes from 'prop-types';

import useLocation from '../../utils/location';

/* Check if children should be shown to the user based on their region */
const RegionLocking = ({ children, cities, provinces, countries }) => {
  const intl = useIntl();
  const [{ city, province, country, loading }] = useLocation();
  const isEmpty =
    (!cities || !cities.length) &&
    (!provinces || !provinces.length) &&
    (!countries || !countries.length);
  const defaultState =
    !isEmpty && provinces && provinces.includes('QC') && intl.locale === 'fr';
  const [regionLocked, setRegionLocked] = useState(defaultState);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isEmpty) {
      setRegionLocked(
        (cities && cities.includes(city)) ||
          (provinces && provinces.includes(province)) ||
          (countries && countries.includes(country)) ||
          (provinces && provinces.includes('QC') && intl.locale === 'fr')
      );
      setIsLoading(loading);
    }
  }, [city, province, country, loading]);

  useEffect(() => {
    setIsLoading(loading);
  }, []);

  if (regionLocked) return null;
  if (!isEmpty && isLoading) return <>{Children.map(children, Loading)}</>;
  return children;
};

RegionLocking.propTypes = {
  children: PropTypes.node.isRequired,
  cities: PropTypes.arrayOf(PropTypes.string),
  provinces: PropTypes.arrayOf(PropTypes.string),
  countries: PropTypes.arrayOf(PropTypes.string),
};

RegionLocking.defaultProps = {
  cities: [],
  provinces: [],
  countries: [],
};

const Loading = (Component) => ({
  ...Component,
  props: {
    ...(Component.props || {}),
    style: {
      ...((Component.props || {}).style || {}),
      opacity: 0.001,
    },
  },
});

export default RegionLocking;
